import { createContext, useContext } from 'react';

export type Theme = 'dark' | 'light' | 'system';
export type ThemeProviderState = { theme: Theme; setTheme: (theme: Theme) => void };
export const initialThemeState: ThemeProviderState = { theme: 'system', setTheme: () => null };

export const ThemeProviderContext = createContext<ThemeProviderState>(initialThemeState);

export function getEffectiveTheme(theme: Theme): 'light' | 'dark' {
  if (theme === 'dark') return 'dark';
  if (theme === 'light') return 'light';
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
